// Preload images in two tiers:
// - CRITICAL: Landing page images — loaded immediately
// - DEFERRED: All other banner/page images — loaded after first paint

const CRITICAL_IMAGES = [
  // Landing page left cards
  "/images/banners/block-builder.webp",
  "/images/banners/ctm-slicer.webp",
  "/images/banners/resource-pack.webp",
  // Landing page right cards
  "/images/banners/office-space-2.webp",
  "/images/banners/product-overview-card.webp",
  "/images/banners/pixelsculpt-resource-pack.webp",
  // Landing page backgrounds
  "/assets/fixed_background.webp",
  "/hero-banner.webp",
];

const DEFERRED_IMAGES = [
  // Legal page banners
  "/images/banners/banner-legal.webp",
  "/images/banners/banner-privacy.webp",
  "/images/banners/banner-terms.webp",
  "/images/banners/banner-roadmap.webp",
  // Product page banners
  "/images/banners/asset-tools.webp",
  "/images/banners/world-builder.webp",
  "/images/banners/product-overview-banner.webp",
  // About page
  "/images/about-us.webp",
  // Landing slideshow banners
  "/assets/banners/TCom_Marble_SlabRed_header.webp",
  "/assets/banners/TCom_CorrodedMedievalMetalA_header.webp",
  "/assets/banners/TCom_DarkWoodVeneer_header.webp",
  "/assets/banners/TCom_Gore3_header.webp",
  "/assets/banners/TCom_Leather_DragonSkin_header.webp",
  "/assets/banners/TCom_MarbleSlabGoldB_header.webp",
  "/assets/banners/TCom_Obsidian_header.webp",
  "/assets/banners/TCom_Rock_CliffGranite_header.webp",
  "/assets/banners/TCom_Rock_CliffMountain_header.webp",
  "/assets/banners/TCom_Wood_TeakVeneer_header.webp",
  // Page shell banners
  "/banner-castle.webp",
  "/banner-city.webp",
  "/banner-medieval.webp",
  "/banner-roman.webp",
];

function preloadList(images) {
  images.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}

// Critical images load immediately
export function preloadCriticalImages() {
  preloadList(CRITICAL_IMAGES);
}

// All remaining images load after first paint
export function preloadAllBanners() {
  preloadList(DEFERRED_IMAGES);
}
